var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningOutlineRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm0-2ZM16 20a1 1 0 0 1-1-1v-8a1 1 0 0 1 2 0v8a1 1 0 0 1-1 1Z",
    fill: "#ff1e1e",
    className: "fill-101820"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.78 30H4.22a3.19 3.19 0 0 1-2.77-1.57 3.13 3.13 0 0 1-.06-3.13L13.17 3.67a3.23 3.23 0 0 1 5.66 0L30.61 25.3a3.13 3.13 0 0 1-.06 3.13A3.19 3.19 0 0 1 27.78 30ZM16 4a1.18 1.18 0 0 0-1.07.63L3.15 26.25a1.12 1.12 0 0 0 0 1.16 1.19 1.19 0 0 0 1 .59h23.63a1.19 1.19 0 0 0 1-.59 1.12 1.12 0 0 0 0-1.16L17.07 4.63A1.18 1.18 0 0 0 16 4Z",
    fill: "#ff1e1e",
    className: "fill-101820"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlineRed);
export default __webpack_public_path__ + "static/media/warning_outline_red.df852c2c51ff85bcffd3c65f288b7e06.svg";
export { ForwardRef as ReactComponent };